module.exports = __webpack_public_path__ + "static/media/St. Louis Bubble Tea Rebrand.c9ca9ca6.jpg";